import React, {
    useCallback, useContext, useEffect, useMemo, useState
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { ModalNextProvider } from '@jutro/components';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { TranslatorContext } from "@jutro/locale";
import { useAuthentication } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import metadata from './BankPaymentMethodComponent.metadata.json5';
import messages from './BankPaymentMethodComponent.messages';
import styles from './BankPaymentMethodComponent.module.scss';
import InstitutionDetails from './InstitutionDetails';

const PAYMENT_METHOD_MESSAGES = {
    bankAccountNoInvalid: 'bankAccountNoInvalid',
    paymentMethodSaveFailed: 'paymentMethodSaveFailed',
    paymentMethodSaveSuccess: 'paymentMethodSaveSuccess',
    fieldEmpty: 'fieldEmpty',
    validationPass: 'validationPass'
};

function BankPaymentMethodComponent(props) {
    const translator = useContext(TranslatorContext);
    const [paymentMehtodStatus, setPaymentMehtodStatus] = useState();
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        updateEFTData: updateEFTDataCallback,
        cancelEFTDataUpdate: cancelEFTDataUpdateCallback,
        initialData,
        editEFTData,
        showBankPaymentFields,
        selectedPaymentMethod
    } = props;

    const [paymentMethod, setPaymentMethod] = useState(selectedPaymentMethod);
    const [showBankFields, setShowBankFields] = useState(showBankPaymentFields);
    const [paymentInstrumentModel, setPaymentInstrumentModel] = useState(initialData);
    const [instituteNumSearch, setInstituteNumSearch] = useState('');
    const [institutionDetails, setInstitutionDetails] = useState([]);
	const [selectedInstitutionValue, updateInstitutionValue] = useState('');
    const [oldInstitutionNumber, setOldInstitutionNumber] = useState();
    const [oldInstitutionName, setOldInstitutionName] = useState();
    const { GatewayBillingService } = useDependencies('GatewayBillingService');
    const { authHeader } = useAuthentication();

    useMemo(() => {
        let data = {
            isValidationRequired: true,
            isPrimary: true
        };
        if (initialData) {
            data = initialData;
             const formatedInstitutionNumberVal= {
                id: 0, 
                displayName: `${initialData.instituteNumber_EY} - ${initialData.instituteName_EY}`
            }
            updateInstitutionValue(formatedInstitutionNumberVal);
        }
        setPaymentInstrumentModel(data);
    }, [initialData]);

    const initializeVM = () => {
        return viewModelService.create(
            paymentInstrumentModel,
            'cc',
            'edge.capabilities.claim.contact.dto.EFTDataDTO'
        );
    };
    let paymentMethodVM = initializeVM();

    const initDefaults = () => {
        paymentMethodVM = initializeVM();
    };


    useEffect(() => {
        initDefaults();
    }, [paymentInstrumentModel]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(paymentMethodVM.value, path, value);
            setPaymentInstrumentModel(paymentMethodVM.value);
        },
        [paymentMethodVM]
    );

    const validateDetails = () => { 
        setPaymentMehtodStatus('');
		_.set(paymentMethodVM, 'bankAccountType.value', paymentMethodVM?.bankAccountType?.aspects?.availableValues[0]?.code);
        if (!paymentMethodVM.aspects.subtreeValid) {
            setPaymentMehtodStatus(PAYMENT_METHOD_MESSAGES.fieldEmpty);
            /* if (typeof updateEFTDataCallback === 'function') {
                updateEFTDataCallback({});
            } */
            return;
        }

        const bankAccountNumber = _.get(paymentMethodVM.value, 'bankAccountNumber');

        if (!(/^\d{7,12}$/.test(bankAccountNumber))) {
            setPaymentMehtodStatus(PAYMENT_METHOD_MESSAGES.bankAccountNoInvalid);
            /* if (typeof updateEFTDataCallback === 'function') {
                updateEFTDataCallback({});
            } */
            return;
        }
        if (typeof updateEFTDataCallback === 'function') {
            updateEFTDataCallback(paymentMethodVM.value).then((response) => {
                if (response === 'success') {
                    setPaymentMehtodStatus(PAYMENT_METHOD_MESSAGES.paymentMethodSaveSuccess);
                    setPaymentInstrumentModel(null);
                    //setPaymentInstrumentModel(initializePaymentModel());
                    //setPaymentMethod('');
                    setShowBankFields(false);
                } else if (response === 'error') {
                    setPaymentMehtodStatus(PAYMENT_METHOD_MESSAGES.paymentMethodSaveFailed);
                } else if ((response === 'validation')) {
                    setPaymentMehtodStatus(PAYMENT_METHOD_MESSAGES.validationPass);
                }
            });
        } else {
            setPaymentMehtodStatus(PAYMENT_METHOD_MESSAGES.validationPass);
        }
    };

    // const showInstituteDetailsOnModal = useCallback((response) => {
    //     const componentProps = {
    //         institutionDetails: response
    //     };
    //     ModalNextProvider.showModal(
    //         <InstitutionDetails {...componentProps} />
    //     ).then((selectedInstituteEntry) => {
    //         if (!_.isEmpty(selectedInstituteEntry)) {
    //             /*writeValue(selectedInstituteEntry.institutionNumber, 'instituteNumber_EY');
    //             writeValue(selectedInstituteEntry.bankName, 'instituteName_EY');*/
    //             const newData = {
    //                 ...paymentMethodVM.value,
    //                 instituteNumber_EY: selectedInstituteEntry.institutionNumber,
    //                 instituteName_EY: selectedInstituteEntry.bankName
    //             };
    //             setPaymentInstrumentModel(newData);
    //         }
    //     });
    // }, [ModalNextProvider, paymentMethodVM, writeValue]);
	
	async function findInstitutionDetails (textInput) { 
        let dataArray = [];
        if (textInput === undefined ) {
            return dataArray;
        }      
        await GatewayBillingService.searchBankInstitute_EY(_.get(paymentMethodVM.value, 'instituteNumber_EY'), null, authHeader)
        .then((response) => {
            let originalValue = [];
            response.forEach((instituteInfo, index) => {
                    dataArray = [...dataArray, {id: index, displayName: `${instituteInfo.institutionNumber} - ${instituteInfo.bankName}`
                }];
                originalValue[index] = instituteInfo;
            });
            setInstitutionDetails(originalValue);
            //showInstituteDetailsOnModal(response);
        });
        return dataArray;
    }

    const handleInstitutionDetails = (value) => {
        if (value) {
            let institution = institutionDetails[value.id];
            // _.set(paymentInstrumentVM.value, 'bankAccountData.instituteNumber_EY', institution.institutionNumber);
            // _.set(paymentInstrumentVM.value, 'bankAccountData.instituteName_EY', institution.bankName);
            writeValue(institution.bankName, 'instituteName_EY');
            writeValue(institution.institutionNumber, 'instituteNumber_EY');
        }
        updateInstitutionValue(value);
    };

   // const findInstitutionDetails = useCallback(() => {
     //   GatewayBillingService.searchBankInstitute_EY(_.get(paymentMethodVM.value, 'instituteNumber_EY'), null, authHeader)
       //     .then((response) => {
         //       setInstitutionDetails(response);
           //     showInstituteDetailsOnModal(response);
            //})
            //.catch((error) => {
                //alert(error);
            //});
    //}, [instituteNumSearch, GatewayBillingService, authHeader, paymentMethodVM, paymentInstrumentModel]);

    const onInstituteNumSearchChange = useCallback((value) => {
        setInstituteNumSearch(value);
    }, []);

    const selectPaymentOptions = (data) => {
        setPaymentMethod(data);
        setShowBankFields(false);
    };
    const showBankDetails = () => {
        setPaymentInstrumentModel({
            isValidationRequired: true,
            isPrimary: true
        });
        setShowBankFields(true);
        updateInstitutionValue('');
    };

    const cancelBankUpdates= useCallback(()=>{
        setShowBankFields(false);
        setInstituteNumSearch('');
        cancelEFTDataUpdateCallback();
        if ((oldInstitutionName != undefined) && (oldInstitutionNumber != undefined)){
            _.set(paymentMethodVM.value, 'instituteName_EY', oldInstitutionName);
            _.set(paymentMethodVM.value, 'instituteNumber_EY', oldInstitutionNumber);
            const formatedInstitutionNumberVal= {
                id: 0, 
                displayName: `${oldInstitutionNumber} - ${oldInstitutionName}`
            }
            updateInstitutionValue(formatedInstitutionNumberVal);
            const newData = {
                ...paymentMethodVM.value,
                instituteNumber_EY: oldInstitutionNumber,
                instituteName_EY: oldInstitutionName
            };
            setPaymentInstrumentModel(newData);
            console.log("selectedInstitutionValue",selectedInstitutionValue);
            console.log("paymentData" ,paymentMethodVM.value);

        }
    },[paymentMethodVM,setPaymentInstrumentModel,paymentInstrumentModel]);

    const setInstitutionName= useCallback(()=>{
        const institutionName = _.get(paymentInstrumentModel, 'instituteName_EY')
        if (selectedInstitutionValue === null) {
            if(institutionName != "-"){
                setOldInstitutionNumber(paymentMethodVM.value.instituteNumber_EY);
                setOldInstitutionName(paymentMethodVM.value.instituteName_EY);
                const newVMData = _.clone(paymentMethodVM);
                _.set(newVMData.value, 'instituteName_EY', '-');
                _.set(newVMData.value, 'instituteNumber_EY', '');
                setPaymentInstrumentModel(newVMData.value);
            }
        }
    },[setOldInstitutionNumber,
        oldInstitutionNumber,
        setOldInstitutionName,
        oldInstitutionName,
        paymentMethodVM,
        setPaymentInstrumentModel])

  
    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true
        },
        paymentMethodErrorMessageContainer: {
            visible:
                !_.isEmpty(paymentMehtodStatus)
                && paymentMehtodStatus !== PAYMENT_METHOD_MESSAGES.validationPass
                && paymentMehtodStatus !== PAYMENT_METHOD_MESSAGES.paymentMethodSaveSuccess
        },
        paymentMethodErrorMessage: {
            message: translator(messages[paymentMehtodStatus])
        },
        paymentMethodSuccessMessage: {
            visible: paymentMehtodStatus === PAYMENT_METHOD_MESSAGES.paymentMethodSaveSuccess
                || paymentMehtodStatus === PAYMENT_METHOD_MESSAGES.validationPass,
            message: translator(messages[paymentMehtodStatus])
        },
        createPaymentMehthodContainer: {
            visible: !editEFTData
        },
        paymentOptionsId: {
            value: paymentMethod
        },
        bankAccountContainer: {
            visible: editEFTData || (paymentMethod === 'eft' && showBankFields)
        },
        /*cancelPaymentButtonId: {
            visible: editEFTData
        },*/
        validateGridItem: {
            visible: editEFTData || (paymentMethod === 'eft' && showBankFields)
        },
        institutionDetailsDT: {
            data: institutionDetails
        },
        instituteNumberSearch: {
            value: instituteNumSearch
        },
		instituteNumber: {
            availableValues: institutionDetails,
            //value: _.get(paymentInstrumentVM.value, 'bankAccountData.instituteNumber_EY')
            value: selectedInstitutionValue
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            validateDetails,
            selectPaymentOptions,
            showBankDetails,
            cancelBankUpdates,
            findInstitutionDetails,
			handleInstitutionDetails,
            onInstituteNumSearchChange,
            setInstitutionName
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (elementId, path) => {
            return readViewModelValue(metadata.pageContent, paymentMethodVM, elementId, path, overrideProps);
        },
        [paymentMethodVM, paymentInstrumentModel, overrideProps]
    );

    const updatModel = useCallback(
        (elementId, path) => {
            return readViewModelValue(metadata.pageContent, paymentMethodVM, elementId, path, overrideProps);
        },
        [paymentMethodVM, paymentInstrumentModel]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={paymentMethodVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onModelChange={updatModel}
            onValueChange={writeValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

BankPaymentMethodComponent.propTypes = {
    updateEFTData: PropTypes.func,
    initialData: PropTypes.object,
    editEFTData: PropTypes.object,
    cancelEFTDataUpdate: PropTypes.func,
    selectedPaymentMethod: PropTypes.string,
    showBankPaymentFields: PropTypes.bool,
};

export default BankPaymentMethodComponent;
